(function () {
	var wrap = document.getElementById("navbarSearch");
	if (!wrap) return;
	var toggle = wrap.querySelector(".navbar__search-toggle");
	var input = wrap.querySelector(".navbar__search-input");
	var form = wrap.querySelector("form");

	function openSearch() {
		wrap.classList.add("is-open");
		toggle.setAttribute("aria-expanded", "true");
		setTimeout(function () {
			input && input.focus();
		}, 10);
	}

	function closeSearch() {
		wrap.classList.remove("is-open");
		toggle.setAttribute("aria-expanded", "false");
	}

	toggle.addEventListener("click", function () {
		// If there is text, submit immediately
		if (input && input.value && input.value.trim() !== "") {
			form.submit();
			return;
		}
		// Otherwise, toggle open/close
		var isOpen = wrap.classList.contains("is-open");
		if (!isOpen) {
			openSearch();
			return;
		}
		closeSearch();
	});

	document.addEventListener("click", function (e) {
		if (!wrap.contains(e.target)) {
			closeSearch();
		}
	});

	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape") {
			closeSearch();
		}
	});
})();
